/**
 * 部门管理
 */
import request from "@/utils/request";


/**
 * 查询部门列表
 */
export function list(param) {
  return request({
    url: "/base/deptdoc/list",
    method: "post",
    data: param
  })
}

/**
 * 查询部门树
 */
export function listTree(param) {
  return request({
    url: "/base/deptdoc/listTree",
    method: "post",
    data: param
  });
}

/**
 * 根据PK查询单据
 */
export function get(pk) {
  return request({
    url: "/base/deptdoc/get/" + pk,
    method: "get"
  });
}

/**
 * 保存单据
 */
export function save(data) {
  return request({
    url: "/base/deptdoc/save",
    method: "post",
    data: data
  });
}

/**
 * 封存
 */
export function seal(pk) {
  return request({
    url: "/base/deptdoc/seal/" + pk,
    method: "get"
  });
}

/**
 * 启用
 */
export function unseal(pk) {
  return request({
    url: "/base/deptdoc/unseal/" + pk,
    method: "get"
  });
}



// WEBPACK FOOTER //
// ./src/api/base/deptdoc.js